import BaseAPI from '@/apis/base/baseApi';

export default class SUApi extends BaseAPI {
  apiName = 'SU';
}
